import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCog } from '@fortawesome/free-solid-svg-icons';
import ConsolePanel from '../shared/ConsolePanel';

const GridSearchMock = () => (
  <div className="space-y-4">
    <ConsolePanel
      title="Optimization"
      context="BTCUSDT 1h -- EMA Cross"
      icon={faCog}
      status="Running"
      lines={[
        { time: '09:12:00', type: 'info', source: 'engine', message: 'Starting grid search -- 420 parameter combinations' },
        { time: '09:12:00', type: 'info', source: 'engine', message: 'fastLength: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50]' },
        { time: '09:12:00', type: 'info', source: 'engine', message: 'slowLength: [10, 20, 30, 40, 50, 60, 70, 80, ..., 200]' },
        { time: '09:12:01', type: 'info', source: 'engine', message: 'Target metric: Sharpe Ratio' },
        { time: '09:14:22', type: 'info', source: 'progress', message: 'Testing combination 280/420 (67%) -- est. 1m 12s remaining' },
        { time: '09:14:22', type: 'info', source: 'progress', message: 'Current best: Sharpe 1.82 (fastLength: 12, slowLength: 24)' },
      ]}
    />

    {/* Best result card */}
    <div className="rounded-lg border border-white/[0.06] overflow-hidden shadow-lg shadow-black/15 font-mono" style={{ background: '#1e1e2e' }}>
      <div className="flex items-center gap-2 px-3 py-2 border-b border-white/[0.06] bg-gray-800/50">
        <FontAwesomeIcon icon={faCheckCircle} className="text-green-400 text-xs" />
        <span className="text-xs text-gray-300">Best Result Found</span>
      </div>
      <div className="p-3 grid grid-cols-3 gap-3">
        {[
          { label: 'Sharpe Ratio', value: '1.82' },
          { label: 'Total Return', value: '+47.3%' },
          { label: 'Max Drawdown', value: '-8.4%' },
          { label: 'Win Rate', value: '58.2%' },
          { label: 'Profit Factor', value: '2.14' },
          { label: 'Total Trades', value: '142' },
        ].map((m) => (
          <div key={m.label}>
            <p className="text-[8px] text-gray-500 uppercase tracking-wider">{m.label}</p>
            <p className="text-[14px] font-bold text-white">{m.value}</p>
          </div>
        ))}
      </div>
      <div className="px-3 pb-2 flex items-center gap-3">
        <div className="flex items-center gap-2 text-[10px] font-mono text-gray-400">
          <span className="bg-gray-800 rounded px-2 py-0.5">fastLength: <span className="text-white font-semibold">12</span></span>
          <span className="bg-gray-800 rounded px-2 py-0.5">slowLength: <span className="text-white font-semibold">24</span></span>
        </div>
      </div>
    </div>
  </div>
);

export default GridSearchMock;
